import type { Category } from '../../store/categoryStore'

interface Props {
  selectedCategory: string
  onSelect: (cat: string) => void
  counts: Record<string, number>
  rootCategories: Category[]
}

export default function CategoryTabs({ selectedCategory, onSelect, counts, rootCategories = [] }: Props) {
  const tabs = [
    { value: 'all', label: 'הכל' },
    ...rootCategories.map(c => ({ value: c.id, label: c.name })),
  ]

  return (
    <div 
      role="tablist" 
      aria-label="סינון קטגוריות" 
      dir="rtl"
      className="flex gap-2 items-center overflow-x-auto scrollbar-hide pb-3"
      style={{ WebkitOverflowScrolling: 'touch' }}
      >
      {tabs.map(tab => {
        const active = selectedCategory === tab.value
        return (
          <button
            key={tab.value}
            role="tab"
            aria-selected={active}
            onClick={() => onSelect(tab.value)}
            className={`flex items-center gap-2.5 px-4 py-2 rounded-full border-none text-[13px]
              cursor-pointer transition-all duration-200 whitespace-nowrap
              ${active
                ? 'bg-[#2D6A4F] text-white font-semibold shadow-[0_2px_8px_rgba(45,106,79,0.25)]'
                : 'bg-[#F2EDE4] text-[#6B6560] font-medium hover:bg-[#EAE4DB]'
              }`}
          >
            {tab.label}
            <span className={`text-[11px] font-semibold px-1.5 py-0.5 rounded-full
              ${active ? 'bg-white/15 text-white' : 'bg-black/[0.06] text-[#595450]'}`}
            >
              {counts[tab.value] ?? 0}
            </span>
          </button>
        )
      })}
    </div>
  )
}